import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Collapse from "@material-ui/core/Collapse";
import MenuItem from "@material-ui/core/MenuItem";
import Tab from "@material-ui/core/Tab";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Menu from "material-ui-popup-state/HoverMenu";
import { usePopupState, bindMenu, bindToggle } from "material-ui-popup-state/hooks";
import * as Dati from "../../Dati";
import * as Glob from "../../Globale";
import { Trad } from "../../components/";

interface IMainNavItemProps {
    Data: Dati.IDatiMenu;
}

const useStyles = makeStyles({
    tab: {
        minWidth: "80px",
        maxWidth: "115px",
        textTransform: "none",
        padding: 0
    }
});

export const _MainNavItem: React.FC<IMainNavItemProps> = ({ Data }) => {
    const classes = useStyles();
    const popupState = usePopupState({ variant: "popover", popupId: `${Data.ID_Menu}` });

    return Data.Azioni == undefined || Data.Azioni.length == 0 || Data.ID_Funzione == undefined ? (
        <Tab tabIndex={0} component="a" href={Data.Indirizzo} label={Trad.Trad(Data.Voce)} className={classes.tab} />
    ) : (
        <ClickAwayListener onClickAway={popupState.close}>
            <div>
                <Tab tabIndex={0} component={Button} endIcon={<ExpandMoreIcon />} label={Trad.Trad(Data.Voce)} className={classes.tab} {...bindToggle(popupState)} />
                <Menu
                    {...bindMenu(popupState)}
                    TransitionComponent={Collapse}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                >
                    {Data.Azioni.map(
                        (item, index) =>
                            Glob.AzioneAbilitata(Data.ID_Funzione, item.Abilitazione) && (
                                <MenuItem component="a" href={item.URL} key={index} onClick={popupState.close}>
                                    {Trad.Trad(item.Azione)}
                                </MenuItem>
                            )
                    )}
                </Menu>
            </div>
        </ClickAwayListener>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/MainNavItem.tsx